<h1>{{ 'turbo.core.CallDialog.txtHeadline' | translate : 'Calling' }}<span *ngIf="receiver"> {{receiver}}...</span></h1>
<div>
    <div>
        <mat-form-field style="width: 100%; min-width: 300px;">
            <textarea matInput placeholder="{{'turbo.core.CallDialog.txtMessage' | translate : 'Notes from call...'}}" required [(ngModel)]="message" matTextareaAutosize matAutosizeMinRows="9" matAutosizeMaxRows="9" [required] [disabled]="calling"></textarea>
        </mat-form-field>
    </div>
    <div style="text-align: center;">
        <button class="btn btn-default" style="margin: 2px;" color="primary" (click)="saveNotes()" [disabled]="!message || calling">{{ 'turbo.core.CallDialog.cmdSend' | translate : 'Save notes' }}</button>
        <button class="btn btn-default" style="margin: 2px;" [mat-dialog-close]="'Cancel'">{{ 'turbo.core.messagebox.cmdCancel' | translate : 'Cancel' }}</button>
    </div>
</div>
<mat-progress-bar mode="indeterminate" style="margin-left: -24px; margin-bottom: -24px; width: calc(100% + 48px); margin-top: 24px;" *ngIf="calling"></mat-progress-bar>
